import { Config } from 'config';
import { useAppSelector } from 'store';
import { Button } from 'components/button';
import { selectAuthUser } from 'store/slices/auth';

export const CloverAuthButton = () => {
  const authUser = useAppSelector(selectAuthUser);

  const link = Config.authCloverApiUrl
    ?.replace(':companyId', String(authUser?.company?.id))
    .replace(':userId', String(authUser?.id));

  return <Button to={link} target="_blank" text="Connect Clover API" />;
};
